import React from 'react'
import { Helmet } from 'react-helmet';
import ImageCarousel from '../components/ImageCarousel';
import TwitterContainer from '../components/TwitterContainer';
import LabPeople from "../assets/images/LabMembers.JPG"

const Home = () => {
    return (
        <div>
            <Helmet>
                <title>Water & Climate Lab | IIT Gandhinagar</title>
                <meta name="description" content="Welcome to Water & Climate Lab at IIT Gandhinagar. At WCL, we undertake cutting-edge research in several areas, including Hydrologic Monitoring and Prediction, Climate and Urban Systems, Understanding Hydrologic Sensitivity and Change, and Climate Extremes. Our team of experienced researchers and students works collaboratively to develop innovative approaches to tackle some of the most pressing challenges related to water and climate."/>
                
            </Helmet>
            <div className='main-container'>
                <header id="head">
                    <div className="banner-content">
                        <h1>Water & Climate Lab</h1>
                        <h2>IIT Gandhinagar</h2>
                    </div>
                </header>



                <div className="section">
                    <div className="section-heading">
                        <h1>Recent Updates</h1>
                    </div>
                </div>
                <ImageCarousel />





                <div className="section">
                    <div className="grid-3-1">
                        <div className="about-section">

                            <h1>Welcome to the Water & Climate Lab at Indian Institute of Technology Gandhinagar.</h1>
                            <p>
                                At WCL, we undertake cutting-edge research in several areas, including Hydrologic Monitoring and Prediction, Climate and Urban Systems, Understanding Hydrologic Sensitivity and Change, and Climate Extremes. Our team of experienced researchers and students works collaboratively to develop innovative approaches to tackle some of the most pressing challenges related to water and climate.</p>

                            <p> We are committed to sharing our research with the broader community and collaborating with other organizations to promote sustainable water and climate management practices. Please explore our website to learn more about our research and activities, and feel free to contact us with any questions or inquiries.
                            </p>
                            <p>
                                If you are interested in graduate studies (M.Tech. and Ph.D.) related to my research (water resources and climate change) and have strong academic and programming background, I am looking for you. Please contact me on <a href="mailto:vmishra@iitgn.ac.in"> vmishra@iitgn.ac.in</a> to discuss the possibilities.
                            </p>


                        </div>
                        <div className="twitter-container">
                            <TwitterContainer/>

                        </div>

                    </div>




                </div>



                <div className="section">
                    {/* <ImageSlider/> */}
                    <div className="home-member-img">
                        <img src={LabPeople} alt='WCL Lab' />
                    </div>




                </div>

            </div>

        </div>


    )
}

export default Home
